<e-card2 class="game-panel-card" padding="4">
  <header class="game-panel-header">
    <div class="game-panel-header-row">
      <h3 class="game-panel-title">{{ t('humanDesign.games.drawChart.title') }}</h3>
      @if (!isFinished()) {
        <button
          eBtn
          type="button"
          size="sm"
          squared
          [color]="progressVisible() ? 'primary' : 'highlight'"
          [icon]="progressVisible() ? 'eye' : 'eye-slash'"
          [tooltip]="t(progressVisible() ? 'humanDesign.games.drawChart.hideProgress' : 'humanDesign.games.drawChart.showProgress')"
          (click)="toggleProgress()"
        ></button>
        <button
          eBtn
          type="button"
          size="sm"
          squared
          [color]="audioEnabled() ? 'primary' : 'highlight'"
          [icon]="audioEnabled() ? 'volume-high' : 'volume-xmark'"
          [tooltip]="t(audioEnabled() ? 'humanDesign.games.drawChart.audioOn' : 'humanDesign.games.drawChart.audioOff')"
          (click)="toggleAudio()"
        ></button>
      }
    </div>
    @if (!isFinished()) {
      @if (targetName(); as name) {
        <p class="game-panel-instruction"
          [innerHTML]="t('humanDesign.games.drawChart.instructionNamed', { name })"></p>
      } @else {
        <p class="game-panel-instruction">{{ t('humanDesign.games.drawChart.instruction') }}</p>
      }
    }
  </header>

  @if (isFinished()) {
    <div class="game-panel-finished" [class.is-perfect]="isPerfectGame()">
      @if (isPerfectGame()) {
        <i eIcon icon="trophy" class="game-panel-finished-trophy" size="2xl"></i>
      } @else {
        <i eIcon icon="award" class="game-panel-finished-trophy" size="2xl"></i>
      }
      <p class="game-panel-finished-title">
        {{ t(isPerfectGame() ? 'humanDesign.games.drawChart.finishedTitlePerfect' : 'humanDesign.games.drawChart.finishedTitle') }}
      </p>
      @if (targetName(); as name) {
        <p class="game-panel-finished-message">
          {{ t(isPerfectGame() ? 'humanDesign.games.drawChart.finishedMessagePerfectNamed' : 'humanDesign.games.drawChart.finishedMessageNamed', { name }) }}
        </p>
      } @else {
        <p class="game-panel-finished-message">
          {{ t(isPerfectGame() ? 'humanDesign.games.drawChart.finishedMessagePerfect' : 'humanDesign.games.drawChart.finishedMessage') }}
        </p>
      }
      <div class="game-panel-stars" [attr.aria-label]="t('humanDesign.games.drawChart.starsAria', { level: scoreLevel() })">
        @for (_ of starIndices(); track $index) {
          <i eIcon icon="star" class="game-panel-star is-filled"></i>
        }
        @for (_ of emptyStarIndices(); track $index) {
          <i eIcon icon="star" class="game-panel-star is-empty"></i>
        }
      </div>
      <p class="game-panel-finished-score" [class.is-perfect]="isPerfectGame()">
        {{ scoreLabel() }} <span class="game-panel-finished-max">/ {{ maxPossibleScore }}</span>
      </p>
    </div>
  } @else {
    @if (progressVisible()) {
      <div class="game-panel-progress">
        <div class="game-panel-progress-bar" role="progressbar"
          [attr.aria-valuenow]="matchPercentage()" aria-valuemin="0" aria-valuemax="100">
          <span class="game-panel-progress-fill" [style.width.%]="matchPercentage()"></span>
        </div>
        <span class="game-panel-progress-label">
          {{ t('humanDesign.games.drawChart.progress', { matched: matchedGates(), total: targetGateCount(), percentage: matchPercentage() }) }}
        </span>
      </div>
    }

    <div class="game-panel-actions">
      <button
        eBtn
        type="button"
        size="sm"
        color="primary"
        icon="check"
        [tooltip]="t('humanDesign.games.drawChart.checkTooltip')"
        (click)="submit()"
      >{{ t('humanDesign.games.drawChart.check') }}</button>
      <button
        eBtn
        type="button"
        size="sm"
        color="highlight"
        icon="lightbulb"
        iconColor="primary-75"
        [tooltip]="t('humanDesign.games.drawChart.hintTooltip')"
        (click)="requestHint()"
      >{{ t('humanDesign.games.drawChart.hint') }}</button>
    </div>

    @if (currentHint(); as hint) {
      <p class="game-panel-hint is-kind-draw" aria-live="polite">{{ hint }}</p>
    }

    @if (checkAllCorrect()) {
      <p class="game-panel-all-correct" aria-live="polite">
        <i eIcon icon="check" iconColor="success"></i>
        {{ t('humanDesign.games.drawChart.allCorrectSoFar') }}
      </p>
    }

    @if (submitErrors().length > 0) {
      <div class="game-panel-errors" aria-live="polite">
        <p class="game-panel-errors-title">{{ t('humanDesign.games.drawChart.errorsTitle') }}</p>
        <ul class="game-panel-errors-list">
          @for (error of submitErrors(); track error.gate) {
            <li class="game-panel-errors-item">
              {{ t('humanDesign.games.drawChart.errorGate', { gate: error.gate }) }}
              <span class="game-panel-errors-center">({{ error.centerLabel }})</span>
              @if (error.wrongColor) {
                <span class="game-panel-errors-kind">&rarr; {{ t('humanDesign.games.drawChart.errorColor') }}</span>
              }
            </li>
          }
        </ul>
      </div>
    }
  }

  <footer class="game-panel-footer">
    <p class="game-panel-score">{{ t('humanDesign.games.drawChart.score') }}: <strong>{{ scoreLabel() }}</strong></p>
    <button
      eBtn
      type="button"
      size="sm"
      color="highlight"
      icon="undo"
      iconColor="primary-75"
      (click)="requestRestart()"
    >{{ t('humanDesign.games.drawChart.restart') }}</button>
  </footer>
</e-card2>
